import moment from "moment-timezone";
import { useTranslation } from "react-i18next";
import * as constants from "../constants";
import { withinTimeFromNow } from "./datetime";

export function getCourseNames(associatedCourses) {
  if (!associatedCourses) return [];
  let namesArr = [];

  if (Array.isArray(associatedCourses)) {
    namesArr = associatedCourses.map(course => {
      return course.name || course.attributes.name;
    });
  } else {
    namesArr = Object.keys(associatedCourses).map((key, index) => {
      return associatedCourses[key].attributes.name;
    });
  }
  return namesArr;
}

export function iltScheduledAt(scheduledTime) {
  if (!scheduledTime) {
    return "";
  }

  const { t } = useTranslation();
  if (scheduledTime === "all_day") {
    return t("courses.scheduledDateTime.allDay");
  }
  return t("courses.scheduledDateTime.scheduled", { time: scheduledTime });
}

export function isIlt(course = {}) {
  return (
    course.courseType &&
    course.courseType.toLowerCase() === constants.courseTypes.ilt.toLowerCase()
  );
}

export function isOnline(course = {}) {
  return (
    course.courseType &&
    course.courseType.toLowerCase() ===
      constants.courseTypes.online.toLowerCase()
  );
}

export const isSessionClosedOut = statusTypeId =>
  statusTypeId === constants.trainingObjectStatusIds.sessionClosedOut;

/**
 * Determines if "Join" should be displayed instead of "Play" for the start button
 * for an ILT.
 *
 * @param  {string} startDate The start date of the session
 * @param  {string} endDate The end date of the session
 * @returns {boolean} True if the current time is within five minutes before the session or
 * before the end of the session, false otherwise.
 */
export const displayJoinButton = (startDate, endDate) => {
  const fiveMinutes = 5 * 60 * 1000; // five minutes in milliseconds

  return (
    startDate &&
    endDate &&
    (withinTimeFromNow(new Date(startDate), fiveMinutes) ||
      moment(Date.now()).isBetween(
        new Date(startDate),
        new Date(endDate),
        null,
        "[]"
      ))
  );
};
